<template>
  <v-container>
    <v-row class="text-center">
      <v-col class="mb-4">
        <v-img
          alt="Raging Pixel Studios Logo"
          src="@/assets/Logos/Logo_stacked.png"
          width="560"
          class="mx-auto"
        />
        <h2 class="mt-3 font-weight-regular black--text">
          An Indie game development studio based in New Jersey.
        </h2>
      </v-col>
    </v-row>
    <v-row class="text-center">
      <v-card
        light
        elevation="4"
        class="rounded-lg my-8 mx-auto pa-5"
        max-width="900"
        min-height="300"
      >
        <v-card-text>
          <div class="display-1 black--text darken-4 text-uppercase">
            Under Construction
          </div>
          <p class="mt-3 black--text darken-4 text-body-1">
            We are a group of developers and artists currently working on PC
            games. Check back soon for more info!
          </p>
          <div class="black--text darken-4 text-body-2 text-left">
            - The Raging Pixel Team
          </div>
        </v-card-text>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "UnderConstruction",

  data: () => ({
    //
  })
};
</script>
